import React, {useState, useEffect} from 'react';
import ItemDetail from '../components/itemdetail/ItemDetail';
import loader from '../img/loading-dog.gif';
import PageError from '../components/pageerror/PageError';
import {Link, useParams} from 'react-router-dom';
import ItemCountContainer from './ItemCountContainer';
import {useCartContext} from '../context/cartContext'
import { ToastContainer, toast } from 'react-toastify';
import { getFirestore } from '../Firebase/Firebase'
import 'react-toastify/dist/ReactToastify.css';

//contiene la logica de traer el item solicitado de la base de datos proporcionada de firebase 
const ItemDetailContainer = () => {
    const [datos, setDatos] = useState({})
    const [notFound, setNotFound] = useState(false);
    const {id} = useParams()
    const {addItems, tost,addItemWish, yaEsta} = useCartContext()
    const [show, setShow] = useState(true);
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        const db = getFirestore();
        const itemCollection = db.collection("items");
        const detailItem = itemCollection.doc(id);
        detailItem.get().then((doc)=>{
           
            if(!doc.exists) { 
                setNotFound(true);
            }
            setTimeout(() => {
                setLoading(true)
              setDatos({id: doc.id, ...doc.data()});  
            }, 2000);
            

        }).catch((err)=>console.log('ocurrio un error', err))
          .finally(()=>console.log('finalizo'))
    
        }, [id]);

        useEffect(() => {
            
        }, [datos,yaEsta])

       //al ejecutar la funcion envia los datos al CarContex. 
    const onAdd = (count) =>{
        addItems(count, datos)
        setShow(!show)
        tost ?
            toast.error('❌ supera cantidad de stock !')
        :
            toast.success('🐶 Agregado al carrito!')
        
    }
    //agrega el producto a la lista de deseos!
    const onAddWish =()=>{
        addItemWish(datos)
        yaEsta ? 
        toast.error('⛔ ya fue agregado!'):
        toast.success('⭐ deseo guardado')
    }
    
    return (
        <>
            <div className="container">
                <div className="row"></div>
                {notFound ? <PageError/> : !loading ?  <img src={loader} className="loader" alt="loader"/> : <><ItemDetail datos={datos} onAddWish={onAddWish}/>
                {show ?  
                 <ItemCountContainer stockT={datos.stockT} onAdd={onAdd} />   
                 : <div className="fin-Comp">
                        <Link to={'/cart'}><button className="btn shop" >Terminar Comprar</button></Link>
                        <Link to={'/category'}><button className="btn shop" >Volver al Catalogo</button></Link>
                    </div>}</>}

                <ToastContainer/>
             </div>   
        </>
    )
}
export default ItemDetailContainer;